import { ref, watch } from '@nuxtjs/composition-api';
export const initializeYandex = (adTags, isMobile) => {
  const isYandexHBLoaded = ref(false);
  const isYandexLoaded = ref(false);
  adTags.__dangerouslyDisableSanitizersByTagID = adTags.__dangerouslyDisableSanitizersByTagID || {};
  if (!isYandexHBLoaded.value) {
    watch(isMobile, () => {
      if (isMobile.value) {
        const adfoxBiddersMap = {
          criteo: '1158170',
          myTarget: '1158171',
          betweenDigital: '1158184',
          adriver: '1158175',
          rtbhouse: '1158174',
          getintent: '1203090',
          alfasense: '1203091',
          facebook: '1180645',
        };
        const adUnits = [
          {
            code: 'adfox_masthead',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457860 } },
              { bidder: 'myTarget', params: { placementId: 621479 } },
              { bidder: 'betweenDigital', params: { placementId: 3426041 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_320x100mob' } },
              { bidder: 'rtbhouse', params: { placementId: 'kprWeXn1S56jI41KIsQz' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_m_300x250_adfox_masthead' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1817' } },
              { bidder: 'facebook', params: { placementId: '414729126108743_414729436108712' } },
            ],
          },
          {
            code: 'adfox_mob1',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457861 } },
              { bidder: 'myTarget', params: { placementId: 621465 } },
              { bidder: 'betweenDigital', params: { placementId: 3426036 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x250mob_1' } },
              { bidder: 'rtbhouse', params: { placementId: 'YgFjMZatS6HY9JEZoXFE' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_m_300x250_adfox_mob1' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1818' } },
              { bidder: 'facebook', params: { placementId: '414729126108743_414729832775339' } },
            ],
          },
          {
            code: 'adfox_mob2',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457862 } },
              { bidder: 'myTarget', params: { placementId: 621468 } },
              { bidder: 'betweenDigital', params: { placementId: 3426037 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x250mob_2' } },
              { bidder: 'rtbhouse', params: { placementId: 'c0URif74mHdXxirDpVaG' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_m_300x250_adfox_mob2' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1819' } },
              { bidder: 'facebook', params: { placementId: '414729126108743_414730006108655' } },
            ],
          },
          {
            code: 'adfox_mob3',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457863 } },
              { bidder: 'myTarget', params: { placementId: 621469 } },
              { bidder: 'betweenDigital', params: { placementId: 3426038 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x250mob_3' } },
              { bidder: 'rtbhouse', params: { placementId: 'e8s9zHKdvCGOufrcXRPH' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_m_300x250_adfox_mob3' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1820' } },
              { bidder: 'facebook', params: { placementId: '414729126108743_414730112775311' } },
            ],
          },
          {
            code: 'adfox_mob4',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457864 } },
              { bidder: 'myTarget', params: { placementId: 621474 } },
              { bidder: 'betweenDigital', params: { placementId: 3426039 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x250mob_4' } },
              { bidder: 'rtbhouse', params: { placementId: 'X3aXd3qHgh8bcFchcP1R' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_m_300x250_adfox_mob4' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1821' } },
              { bidder: 'facebook', params: { placementId: '414729126108743_414730249441964' } },
            ],
          },
        ];
        const userTimeout = 1200;
        window.YaHeaderBiddingSettings = { biddersMap: adfoxBiddersMap, adUnits, timeout: userTimeout };
      } else {
        const adfoxBiddersMap = {
          criteo: '1158170',
          myTarget: '1158171',
          betweenDigital: '1158184',
          adriver: '1158175',
          rtbhouse: '1158174',
          getintent: '1203090',
          alfasense: '1203091',
        };
        const adUnits = [
          {
            code: 'adfox_mid1',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457867 } },
              { bidder: 'myTarget', params: { placementId: 659224 } },
              { bidder: 'betweenDigital', params: { placementId: 3615464 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x250_1' } },
              { bidder: 'rtbhouse', params: { placementId: 'mdut5P2Zv9kKSlL8ZGsr' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_adfox_mid1_300x250' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_2240' } },
            ],
          },
          {
            code: 'adfox_mid2',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'myTarget', params: { placementId: 659225 } },
              { bidder: 'betweenDigital', params: { placementId: 3615465 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x250_2' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_adfox_mid2_300x250' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_2241' } },
            ],
          },
          {
            code: 'adfox_top1',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457865 } },
              { bidder: 'myTarget', params: { placementId: 659220 } },
              { bidder: 'betweenDigital', params: { placementId: 3615466 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x250_3' } },
              { bidder: 'rtbhouse', params: { placementId: 'ZK6je8MKWsiDP464K9GV' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_adfox_top1_300x250' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_2242' } },
            ],
          },
          {
            code: 'adfox_top2',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'myTarget', params: { placementId: 659221 } },
              { bidder: 'betweenDigital', params: { placementId: 3615467 } },
              { bidder: 'rtbhouse', params: { placementId: 'XxfsqT3XronTL7zxZqHL' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_adfox_top2_300x250' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_2243' } },
            ],
          },
          {
            code: 'adfox_mid21',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457868 } },
              { bidder: 'myTarget', params: { placementId: 664131 } },
              { bidder: 'betweenDigital', params: { placementId: 3633303 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x250_4' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_adfox_mid21_300x250' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_2244' } },
            ],
          },
          {
            code: 'adfox_mid22',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'myTarget', params: { placementId: 664136 } },
              { bidder: 'betweenDigital', params: { placementId: 3633304 } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_adfox_mid22_300x250' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_2245' } },
            ],
          },
          {
            code: 'adfox_bot1',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457866 } },
              { bidder: 'myTarget', params: { placementId: 664137 } },
              { bidder: 'betweenDigital', params: { placementId: 3633305 } },
              { bidder: 'rtbhouse', params: { placementId: 'BZG0umP8s6qeAGsl46WU' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_adfox_bot1_300x250' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_2246' } },
            ],
          },
          {
            code: 'adfox_bot2',
            sizes: [[300, 250]],
            bids: [
              { bidder: 'myTarget', params: { placementId: 664139 } },
              { bidder: 'betweenDigital', params: { placementId: 3633306 } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_adfox_bot2_300x250' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_2247' } },
            ],
          },
          {
            code: 'adfox_side1',
            sizes: [[300, 600]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457870 } },
              { bidder: 'myTarget', params: { placementId: 659207 } },
              { bidder: 'betweenDigital', params: { placementId: 3614912 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x600_1' } },
              { bidder: 'rtbhouse', params: { placementId: 'c8iiUwGJX2N4AxlxtvfI' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_300x600_adfox_side1' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1824' } },
            ],
          },
          {
            code: 'adfox_side2',
            sizes: [[300, 600]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457871 } },
              { bidder: 'myTarget', params: { placementId: 659209 } },
              { bidder: 'betweenDigital', params: { placementId: 3614913 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x600_2' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_300x600_adfox_side2' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1825' } },
            ],
          },
          {
            code: 'adfox_side3',
            sizes: [[300, 600]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457872 } },
              { bidder: 'myTarget', params: { placementId: 659211 } },
              { bidder: 'betweenDigital', params: { placementId: 3614914 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x600_3' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_300x600_adfox_side3' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1826' } },
            ],
          },
          {
            code: 'adfox_side4',
            sizes: [[300, 600]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457873 } },
              { bidder: 'myTarget', params: { placementId: 659213 } },
              { bidder: 'betweenDigital', params: { placementId: 3614915 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_300x600_4' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_300x600_adfox_side4' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1827' } },
            ],
          },
          {
            code: 'adfox_head',
            sizes: [[970, 250]],
            bids: [
              { bidder: 'criteo', params: { placementId: 1457874 } },
              { bidder: 'myTarget', params: { placementId: 659205 } },
              { bidder: 'betweenDigital', params: { placementId: 3614957 } },
              { bidder: 'adriver', params: { placementId: '20:onedio_970x250' } },
              { bidder: 'rtbhouse', params: { placementId: 'gTCl6ACrGyA7bIhF0LuM' } },
              { bidder: 'getintent', params: { placementId: '134_onedio.ru_d_970x250_adfox_head' } },
              { bidder: 'alfasense', params: { placementId: 'direct_otm_1823' } },
            ],
          },
        ];
        const userTimeout = 1200;
        window.YaHeaderBiddingSettings = { biddersMap: adfoxBiddersMap, adUnits, timeout: userTimeout };
      }
    });
    adTags.script.push(
      {
        hid: 'yandexHB',
        src: 'https://yandex.ru/ads/system/header-bidding.js',
        async: true,
        callback: () => {
          // console.log('LOADED GPT');
          isYandexHBLoaded.value = true;
        },
      },
      {
        hid: 'yandexHBInit',
        innerHTML: `var adfoxBiddersMap={criteo:"1158170",myTarget:"1158171",betweenDigital:"1158184",adriver:"1158175",rtbhouse:"1158174",getintent:"1203090",alfasense:"1203091"};adUnits=[{code:"adfox_mid1",sizes:[[300,250]],bids:[{bidder:"criteo",params:{placementId:1457867}},{bidder:"myTarget",params:{placementId:659224}},{bidder:"betweenDigital",params:{placementId:3615464}},{bidder:"adriver",params:{placementId:"20:onedio_300x250_1"}},{bidder:"rtbhouse",params:{placementId:"mdut5P2Zv9kKSlL8ZGsr"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_adfox_mid1_300x250"}},{bidder:"alfasense",params:{placementId:"direct_otm_2240"}}]},{code:"adfox_mid2",sizes:[[300,250]],bids:[{bidder:"myTarget",params:{placementId:659225}},{bidder:"betweenDigital",params:{placementId:3615465}},{bidder:"adriver",params:{placementId:"20:onedio_300x250_2"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_adfox_mid2_300x250"}},{bidder:"alfasense",params:{placementId:"direct_otm_2241"}}]},{code:"adfox_top1",sizes:[[300,250]],bids:[{bidder:"criteo",params:{placementId:1457865}},{bidder:"myTarget",params:{placementId:659220}},{bidder:"betweenDigital",params:{placementId:3615466}},{bidder:"adriver",params:{placementId:"20:onedio_300x250_3"}},{bidder:"rtbhouse",params:{placementId:"ZK6je8MKWsiDP464K9GV"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_adfox_top1_300x250"}},{bidder:"alfasense",params:{placementId:"direct_otm_2242"}}]},{code:"adfox_top2",sizes:[[300,250]],bids:[{bidder:"myTarget",params:{placementId:659221}},{bidder:"betweenDigital",params:{placementId:3615467}},{bidder:"rtbhouse",params:{placementId:"XxfsqT3XronTL7zxZqHL"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_adfox_top2_300x250"}},{bidder:"alfasense",params:{placementId:"direct_otm_2243"}}]},{code:"adfox_mid21",sizes:[[300,250]],bids:[{bidder:"criteo",params:{placementId:1457868}},{bidder:"myTarget",params:{placementId:664131}},{bidder:"betweenDigital",params:{placementId:3633303}},{bidder:"adriver",params:{placementId:"20:onedio_300x250_4"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_adfox_mid21_300x250"}},{bidder:"alfasense",params:{placementId:"direct_otm_2244"}}]},{code:"adfox_mid22",sizes:[[300,250]],bids:[{bidder:"myTarget",params:{placementId:664136}},{bidder:"betweenDigital",params:{placementId:3633304}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_adfox_mid22_300x250"}},{bidder:"alfasense",params:{placementId:"direct_otm_2245"}}]},{code:"adfox_bot1",sizes:[[300,250]],bids:[{bidder:"criteo",params:{placementId:1457866}},{bidder:"myTarget",params:{placementId:664137}},{bidder:"betweenDigital",params:{placementId:3633305}},{bidder:"rtbhouse",params:{placementId:"BZG0umP8s6qeAGsl46WU"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_adfox_bot1_300x250"}},{bidder:"alfasense",params:{placementId:"direct_otm_2246"}}]},{code:"adfox_bot2",sizes:[[300,250]],bids:[{bidder:"myTarget",params:{placementId:664139}},{bidder:"betweenDigital",params:{placementId:3633306}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_adfox_bot2_300x250"}},{bidder:"alfasense",params:{placementId:"direct_otm_2247"}}]},{code:"adfox_side1",sizes:[[300,600]],bids:[{bidder:"criteo",params:{placementId:1457870}},{bidder:"myTarget",params:{placementId:659207}},{bidder:"betweenDigital",params:{placementId:3614912}},{bidder:"adriver",params:{placementId:"20:onedio_300x600_1"}},{bidder:"rtbhouse",params:{placementId:"c8iiUwGJX2N4AxlxtvfI"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_300x600_adfox_side1"}},{bidder:"alfasense",params:{placementId:"direct_otm_1824"}}]},{code:"adfox_side2",sizes:[[300,600]],bids:[{bidder:"criteo",params:{placementId:1457871}},{bidder:"myTarget",params:{placementId:659209}},{bidder:"betweenDigital",params:{placementId:3614913}},{bidder:"adriver",params:{placementId:"20:onedio_300x600_2"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_300x600_adfox_side2"}},{bidder:"alfasense",params:{placementId:"direct_otm_1825"}}]},{code:"adfox_side3",sizes:[[300,600]],bids:[{bidder:"criteo",params:{placementId:1457872}},{bidder:"myTarget",params:{placementId:659211}},{bidder:"betweenDigital",params:{placementId:3614914}},{bidder:"adriver",params:{placementId:"20:onedio_300x600_3"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_300x600_adfox_side3"}},{bidder:"alfasense",params:{placementId:"direct_otm_1826"}}]},{code:"adfox_side4",sizes:[[300,600]],bids:[{bidder:"criteo",params:{placementId:1457873}},{bidder:"myTarget",params:{placementId:659213}},{bidder:"betweenDigital",params:{placementId:3614915}},{bidder:"adriver",params:{placementId:"20:onedio_300x600_4"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_300x600_adfox_side4"}},{bidder:"alfasense",params:{placementId:"direct_otm_1827"}}]},{code:"adfox_head",sizes:[[970,250]],bids:[{bidder:"criteo",params:{placementId:1457874}},{bidder:"myTarget",params:{placementId:659205}},{bidder:"betweenDigital",params:{placementId:3614957}},{bidder:"adriver",params:{placementId:"20:onedio_970x250"}},{bidder:"rtbhouse",params:{placementId:"gTCl6ACrGyA7bIhF0LuM"}},{bidder:"getintent",params:{placementId:"134_onedio.ru_d_970x250_adfox_head"}},{bidder:"alfasense",params:{placementId:"direct_otm_1823"}}]}];var userTimeout=1200;window.YaHeaderBiddingSettings={biddersMap:adfoxBiddersMap,adUnits:adUnits,timeout:userTimeout};`,
      }
    );
    adTags.__dangerouslyDisableSanitizersByTagID.yandexHBInit = ['innerHTML'];
  }
  if (!isYandexLoaded.value) {
    adTags.script.push(
      {
        hid: 'yandexInit',
        innerHTML: `window.yaContextCb = window.yaContextCb || []`,
      },
      {
        hid: 'yandex',
        src: 'https://yandex.ru/ads/system/context.js',
        async: true,
        callback: () => {
          // console.log('LOADED GPT');
          isYandexLoaded.value = true;
        },
      }
    );
    adTags.__dangerouslyDisableSanitizersByTagID.yandexInit = ['innerHTML'];
  }
};
